




































/* eslint-disable */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import UploadFileForm from '@/components/form/UploadFileForm.vue';
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import JSZip, { file } from 'jszip';
import hexabaseState from '@/store/hexabase';
import authState from '@/store/auth';
import { FileFields } from '@/services/hexabase/types';
import axios from 'axios';
import Papa from 'papaparse';

interface ResultUpload {
  success: boolean;
  data: any;
}

interface ItemField {
  KIMONSAKICODE: string;
  KIMONSAKINAME: string;
  ZEIGAKU: string;
  FILENAME?: string;
  id?: string;

}

@Component({
  components: {
    SingleText,
    UploadFileForm,
    SideMenu,
    Header,
    PageInfoBar,
    Dialog
  }
})
export default class UploadFileScreen extends Vue {
  inheritAttrs = false;

  @Prop({ default: () => ({}) })
  private item: any;

  private storeItems: any = [];
  private confirmDialog = false;
  private actionResponse: any = null;

  private datastorePrimaryKey = "KOMONSAKICODE";

  private token = authState.token
  private applicationId = hexabaseState.applicationId;
  private mainDsId = "";

  private snackbar = false;
  private snackbarMessage = '';
  private snackbarColor = '';
  private snackbarTimeout = 2000;
  private successColor = 'green';
  private itemsDecoded: ItemField[] = [];
  private closeButtonColor = 'rgba(29, 32, 49, 0.8)';

  async created() {
    this.initializeEvent();
    this.mainDsId = hexabaseState.datastoreIds["csv_database"];

    this.item.projectFilecolumns = [
      { "text": "顧問先コード", "value": "parentDirectory" },
      { "text": "ファイル名", "value": "name" },
      {
        "text": "",
        "value": "file_id",
        "sortable": false,
        "width": 70
      }]
    this.storeItems = [];

    this.item.accept = "application/x-zip-compressed,text/csv";
  }

  private initializeEvent() {
    const responseData: any = {};
    responseData.action = 'projectFileUploadTab';
    responseData.eventName = 'initializeEvent';
    return responseData;
  }

  private confirmProjectFileButtonAction(response: any) {
    if (response.name === 'regist') {
      this.actionResponse = response;
      this.confirmDialog = true;
    } else {
      this.projectFileButtonAction(response);
    }
  }

  private handleConfirmedAction({ isAgree }: { isAgree: boolean }) {
    this.confirmDialog = false;
    if (isAgree) {
      this.projectFileButtonAction(this.actionResponse);
    }
  }
  private async projectFileButtonAction(response: any) {
    response.action = 'projectFileUploadTab';
    response.eventName = 'projectFileButtonAction';

    if (response.name === 'delete') {
      const list_delete_id = [];
      for (const item of response.select) {
        list_delete_id.push(item.id);
      }
      this.deleteFilesByIds(list_delete_id);
    }

    if (response.name === 'regist') {


      // Code for import data with csv file
      // let isAborted = false;
      // const uploadPromises = this.storeItems.map(async (item: any) => {
      //   if (isAborted) return;

      //   try {
      //     const zipFile = item.content;
      //     let fileContent;
      //     if (zipFile.async) {
      //       fileContent = await zipFile.async('blob');
      //     } else {
      //       fileContent = zipFile;
      //     }

      //     if (isAborted) return;

      //     const responseUpload = await this.uploadFileToHexabase(fileContent, item.name);
      //     if (!responseUpload.success) {
      //       if (!isAborted) {
      //         this.setError(responseUpload.data);
      //       }
      //       isAborted = true;
      //       throw new Error(`Upload failed for ${item.name}`);
      //     }
      //     if (isAborted) return;

      //     const responseCheck = await this.checkStream(responseUpload.data.streamId);
      //     if (!responseCheck.success) {
      //       if (!isAborted) {
      //         this.setError("Error in:" + item.name + " - " + responseCheck.data);
      //       }
      //       isAborted = true;
      //       throw new Error(`Upload failed for ${item.name}`);
      //     }
      //   } catch (error) {
      //     console.error(error);
      //     isAborted = true;
      //     throw error;
      //   }
      // });

      // try {
      //   hexabaseState.setIsLoading(true);
      //   await Promise.all(uploadPromises);
      //   if (!isAborted) {
      //     this.showSnackbar('登録完了しました！', this.successColor);
      //   }
      // } catch (error) {
      //   console.error(error);
      // } finally {
      //   hexabaseState.setIsLoading(false);
      // }

      let isAborted = false;
      const uploadPromises = this.itemsDecoded.map(async (item: any) => {
        if (isAborted) return;

        try {
          const responseUpload = await this.createItem(item);
          if (!responseUpload.success) {
            if (!isAborted) {
              this.setError(responseUpload.data);
            }
            isAborted = true;
            throw new Error(`Upload failed for ${item.FILENAME}`);
          }
        } catch (error) {
          console.error(error);
          isAborted = true;
          throw error;
        }
      });

      try {
        hexabaseState.setIsLoading(true);
        await Promise.all(uploadPromises);
        if (!isAborted) {
          this.showSnackbar('登録完了しました！', this.successColor);
        }
      } catch (error) {
        console.error(error);
      } finally {
        hexabaseState.setIsLoading(false);
      }


    }
    return response;
  }

  private async setProjectInputFiles(files: File[]) {
    const responseData: any = {};
    responseData.action = 'projectFileUploadTab';
    responseData.eventName = 'setProjectInputFiles';
    responseData.files = files;


    for (const file of files) {
      if (file.type === 'application/x-zip-compressed') {
        const zip = new JSZip();
        const zipContent = await zip.loadAsync(file);
        for (const fileName in zipContent.files) {
          const zipFile = zipContent.files[fileName];
          const zipFileData = await zipFile.async("uint8array");
          const typeOfFile = this.getFileType(zipFile.name);
          if (typeOfFile === 'text/csv') {
            const parentDirectory = zipFile.name.substring(0, zipFile.name.lastIndexOf('/'));
            const fileNameOnly = zipFile.name.split('/').pop()!;
            const newZipFile: FileFields = { id: `${Date.now()}-${Math.random()}`, name: fileNameOnly, size: zipFileData.length, content: zipFile, parentDirectory: parentDirectory };
            const csvContent = await zipFile.async("string");
            const items = this.parseCsvToItems(csvContent, fileNameOnly, newZipFile.id);
            this.itemsDecoded.push(...items);
            this.storeItems.push(newZipFile);
          }
        }
      } else if (file.type === 'text/csv') {
        const fileNameOnly = file.name;
        const csvContent = await file.text();
        const newFile: FileFields = { id: `${Date.now()}-${Math.random()}`, name: file.name, size: file.size, content: file };
        const items = this.parseCsvToItems(csvContent, fileNameOnly, newFile.id);
        this.itemsDecoded.push(...items);
        this.storeItems.push(newFile);
      }
    }

    return responseData;
  }

  private setSubmitDisable(invalid: boolean, errors: { [x: string]: string[] }): boolean {
    let obj: string[] = [];
    for (const [key, value] of Object.entries(errors)) {
      if (value.length > 0) {
        obj = [...obj, key];
      }
    }
    let passFlg = false;
    if (obj.length === 1 && obj[0] === 'count') {
      passFlg = true;
    }

    if (this.storeItems.length === 0) return true;
    if (passFlg) return false;
    return invalid;
  }

  private deleteFilesByIds(ids: string[]) {
    this.itemsDecoded = this.itemsDecoded.filter((item: any) => !ids.includes(item.id));
    const updatedList = this.storeItems.filter((file: any) => !ids.includes(file.id));
    this.storeItems = updatedList;
  }

  private getFileType(fileName: string): string {
    const extension = fileName.split('.').pop();
    switch (extension) {
      case 'csv':
        return 'text/csv';
      case 'txt':
        return 'text/plain';
      case 'json':
        return 'application/json';
      default:
        return 'unknown';
    }
  }


  private parseCsvToItems(csvContent: string, fileName: string, id: string): ItemField[] {
      // First remove the .csv extension
    let nameWithoutExtension = fileName.replace(/\.csv$/i, '');
    
    // Then extract the part after the underscore if it exists
    const underscoreIndex = nameWithoutExtension.indexOf('_');
    if (underscoreIndex !== -1) {
      nameWithoutExtension = nameWithoutExtension.substring(underscoreIndex + 1);
    }
    const parsedCsv = Papa.parse(csvContent, { header: true, skipEmptyLines: true });
    const items = parsedCsv.data.map((row: any) => {
      // Check if ZEIGAKU exists and starts with backslash
      if (row.ZEIGAKU && typeof row.ZEIGAKU === 'string' && row.ZEIGAKU.startsWith('\\')) {
        // Remove the backslash character from the beginning
        row.ZEIGAKU = row.ZEIGAKU.substring(1);
      }

      return { ...row, FILENAME: nameWithoutExtension, id: id };
    });
    return items;
  }

  private addFilenameToCsv(csvContent: string, fileName: string): string {
    const parsedCsv = Papa.parse(csvContent, { header: true, skipEmptyLines: true });
    const updatedData = parsedCsv.data.map((row: any) => ({ ...row, FILENAME: fileName }));
    const updatedCsvContent = Papa.unparse(updatedData);
    return updatedCsvContent;
  }

  private async uploadFileToHexabase(fileContent: any, name: string): Promise<ResultUpload> {
    const formData = new FormData();
    formData.append('file', fileContent);
    formData.append('filename', name);
    formData.append('key_field_displayid', this.datastorePrimaryKey);

    try {
      const response = await axios.post(`https://api.hexabase.com/api/v0/applications/${this.applicationId}/datastores/${this.mainDsId}/import`, formData, {
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        return {
          success: true,
          data: {
            streamId: response.data.stream_id,
            tempDatastoreId: response.data.temp_datastore_id
          },
        };
      } else {
        return {
          success: false,
          data: response.data.error
        };
      }
    }
    catch (error) {
      console.error(error);
      return {
        success: false,
        data: "Error when upload csv file"
      };
    }
  }

  private async createItem(item: any): Promise<ResultUpload> {
    try {

      const body = {
        item: item
      }

      const response = await axios.post(`https://api.hexabase.com/api/v0/applications/${this.applicationId}/datastores/${this.mainDsId}/items/new`, body, {
        headers: {
          'Authorization': `Bearer ${this.token}`
        },
      });

      if (response.status === 200) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          data: response.statusText
        };
      }
    } catch (error) {
      console.error(error);
      return {
        success: false,
        data: "Error when create item"
      };
    }
  }

  private async checkResultImport(tempDatastoreId: string): Promise<ResultUpload> {
    try {

      const response = await axios.get(`https://api.hexabase.com/api/v0/datastores/${this.mainDsId}/import/${tempDatastoreId}`, {
        headers: {
          'Authorization': `Bearer ${this.token}`
        },
      });

      if (response.status === 200) {
        if (response.data.errors == null) {
          return {
            success: true,
            data: ""
          };
        } else {
          return {
            success: false,
            data: response.data.errors
          };
        }
      } else {
        return {
          success: false,
          data: response.statusText
        };
      }
    } catch (error) {
      console.error(error);
      return {
        success: false,
        data: "Error checking import result"
      };
    }
  }

  private setError(errorMessage: string): void {
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  private async checkStream(streamId: string): Promise<ResultUpload> {
    try {
      const response = await axios.get(`https://api.hexabase.com/api/v0/tasks?stream_id=${streamId}&all=true`, {
        headers: {
          'Authorization': `Bearer ${this.token}`
        },
      });

      let keyStream: string | undefined;
      if (response.status === 200) {
        for (const key in response.data) {
          keyStream = key;
        }
        if (keyStream === undefined) {
          return {
            success: false,
            data: "Stream ID not found"
          };
        }
        const statusId = response.data[keyStream]?.status?.id;
        if (statusId === 0 || statusId === 1) {
          await this.sleep(1000); // optional
          return this.checkStream(streamId);
        } else if (statusId === 2) {
          return {
            success: true,
            data: ""
          };
        } else {
          return {
            success: false,
            data: "Error: " + (response.data[keyStream].status?.name || "Unknown error")
          };
        }
      } else {
        return {
          success: false,
          data: response.statusText
        };
      }
    } catch (error) {
      console.error(error);
      return {
        success: false,
        data: "Error checking import result"
      };
    }
  }

  private sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private showSnackbar(message: string, color: string) {
    this.snackbarMessage = message;
    this.snackbarColor = color;
    this.snackbar = true;
  }
}
